module.exports = __webpack_public_path__ + "img/code-14.184782be.png";